import React from 'react'

type Props = {
    onChange: Function,
    className?: string,
    value: number
}

export default function QuantitySelect({onChange, className='', value}: Props) {
    const [showInput, setShowInput] = React.useState(false);
    const inputRef = React.useRef<HTMLInputElement>(null);
    const lastInputTypeRef = React.useRef('');

    React.useEffect(() => {
        //Adding this native event listener allows us to track the type of input
        //made to the 10+ quantity input. This means we can revert the
        //input to the usual select immediately if the change is made through
        //the input's arrow buttons, but wait until blur if it's typed
        //manually.
        const handleNativeInputEvent = (event: any) => {
            lastInputTypeRef.current = event.inputType || '';
        };
      
        const inputElement = inputRef.current;
        if (inputElement) {
            inputElement.addEventListener('input', handleNativeInputEvent);
        }
      
        return () => {
            if (inputElement) {
                inputElement.removeEventListener('input', handleNativeInputEvent);
            }
        };
    },[showInput]);

    const handleChange = (event : React.ChangeEvent<HTMLInputElement> | 
                          React.ChangeEvent<HTMLSelectElement>) => {
        const val = event.currentTarget.value;
        const inputType = lastInputTypeRef.current;

        //timeout is set to defer execution of this code until 
        //the native input event handler has finished setting the
        //lastInputTypeRef value
        setTimeout(() => {    
            if (!showInput && val == '10+'){
                setShowInput(true);
                onChange(10);
            }
            else{
                const valInt = parseInt(val);
                if (inputType != 'insertText' && 
                    !inputType.includes('deleteContent') &&
                    valInt < 10) {
                    setShowInput(false);
                }
                onChange(valInt);
            }
        }, 0)
    }

    const handleBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = parseInt(event.currentTarget.value);
        if (val < 10){
            setShowInput(false);
        }
        onChange(val);
    }

    let content = <></>;
    if (showInput){
        const fullClassName = `qty-input ${className}`;
        content = (
            <input ref={inputRef} value={value} className={fullClassName} onChange={handleChange} onBlur={handleBlur} name='qty' type="number" max={99} min={1} maxLength={2} />
        )
    }
    else{
        const fullClassName = `qty-select ${className}`;
        content = (
            <select value={value} className={fullClassName} name='qty' onChange={handleChange}>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10+">10+</option>
            </select>
        )
    }

    return (
        <div>
            {content}
        </div>
    )
}